module.exports = __webpack_public_path__ + "img/hontai_L2532.3e663e71.png";